import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback, Button } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// action
import { registerUser, apiError, resetRegisterFlag } from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

//import images 
import logoLight from "../../assets/images/DBinishgt-logowhite.svg";
import logoDark from "../../assets/images/DBinsight-logodark.svg";
import logodarkbeta from "../../assets/images/DBinsightai-Horizonlogo.svg";
import logolightbeta from "../../assets/images/DBinsightai-Horizonlogo-white.svg";

import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { Spinner } from "reactstrap";
import { createSelector } from "reselect";

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { invalid } from "moment";
import { GoogleReCaptcha , useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { parsePhoneNumberFromString , parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';
import { useCallback } from "react";
import { country } from "../../common/data";


const Register = () => {

 

  const [passwordShow, setPasswordShow] = useState(false);
  const [confrimPasswordShow, setConfrimPasswordShow] = useState(false);

  const history = useNavigate();
  const dispatch = useDispatch();

  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
  const [token, setToken] = useState(null);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onVerify = useCallback((token) => {
    setToken(token);
  }, []);

  const doSomething = () => {
    /* do something like submit a form and then refresh recaptcha */
    setRefreshReCaptcha((r) => !r);
  };

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      // console.log('Execute recaptcha not yet available');
      return;
    }
    const recTokenResult = await executeRecaptcha('contactForm');
    setToken(recTokenResult);
  }, [executeRecaptcha]);

  useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify, refreshReCaptcha]);

  // Refresh the reCAPTCHA every 10 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setRefreshReCaptcha((prev) => !prev);
    }, 10000); // 10 seconds in milliseconds

    return () => clearTimeout(timer); // Clear the timeout when component unmounts or re-renders
  }, [refreshReCaptcha]);



  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      username: '',
      phone: '',
      // first_name: '',
      password: '',
      confirm_password: '',
      agree_on_terms:false
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid Email').required("Please Enter Your Email"),
      // first_name: Yup.string().required("Please Enter Your Username"),
      username: Yup.string().required('Please Enter Your Username'),
      phone: Yup.string()
        .matches(/^[0-9]+$/, 'Phone number must contain only numbers') // Check for numbers
        // .min(8, 'Phone number must be at least 8 digits')              // Check for minimum 10 digits
        // .max(15, 'Phone number must be at least 15 digits') 

        .required('Please Enter Your Phone Number'),
      password: Yup.string()
        .min(8, 'Password must be at least 8 characters long')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/\d/, 'Password must contain at least one number')
        // .matches(/[@$!%*?&+-]/, 'Password must contain at least one special character')
        .required("Please Enter Your Password"),
      confirm_password: Yup.string().oneOf(
        [Yup.ref('password')],
        "Confirm Password Isn't Match"
      ).required('Please confirm your password'),
      agree_on_terms:Yup.boolean()
      .oneOf([true], 'You must accept the terms and conditions')
      .required('You must accept the terms and conditions'),
    }),
   
    onSubmit: (values) => {
   
      setRefreshReCaptcha(r => !r);
      values.recaptcha_response = token
      // console.log(values)
      dispatch(registerUser(values));
    }
  });

  const selectLayoutState = (state) => state.Account;
  const account_details = useSelector((state) => state.Account)

  const registerdatatype = createSelector(
    selectLayoutState,
    (account) => ({
      success: account.success,
      error: account.error
    })
  );
  // Inside your component
  const {
    error, success
  } = useSelector(registerdatatype);

  useEffect(() => {
    dispatch(apiError(""));
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      setTimeout(() => history("/login"), 3000);
    }

    setTimeout(() => {
      dispatch(resetRegisterFlag());
    }, 3000);

  }, [dispatch, success, error, history]);

  // document.title = "Basic SignUp |DBInsight - React Admin & Dashboard Template";
  const [phone, setPhone] = useState('');

  return (
    <React.Fragment>
      {/* <GoogleReCaptcha
                           onVerify={onVerify}
                           refreshReCaptcha={refreshReCaptcha}
                          /> */}
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      {/* <img className="light" src={logoLight} alt="" />
                      <img className="dark" src={logoDark} alt="" /> */}
                      <img className='light' src={logolightbeta} alt="" style={{width:'100%'}}/>
                      <img className="dark" src={logodarkbeta} alt="" style={{width:'100%'}}/>
                    </Link>
                  </div>
                  {/* <p className="mt-3 fs-15 fw-medium">Premium Admin & Dashboard Template</p> */}
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4 card-bg-fill">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Create New Account</h5>
                      {/* <p className="text-muted">Get your freeDBInsight account now</p> */}
                    </div>
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        className="needs-validation"
                        action="#"
                      >
                        {success && success ? (
                          <>
                            {/* {toast("Your Redirect To Login Page...", {
                              position: "top-right",
                              hideProgressBar: false,
                              className: "bg-success text-white",
                              progress: undefined,
                              toastId: "",
                            })} */}
                            <Alert color="success">
                              Register User Successfully and Your Redirect To
                              Login Page...
                            </Alert>
                          </>
                        ) : null}

                        {/* <ToastContainer autoClose={2000} limit={1} /> */}
                        {error && error ? (
                          <Alert color="danger">
                            <div>{account_details.registrationError}</div>
                          </Alert>
                        ) : null}

                        <div className="mb-3">
                          <Label htmlFor="useremail" className="form-label">
                            Email <span className="text-danger">*</span>
                          </Label>
                          <Input
                            id="email"
                            name="email"
                            className="form-control"
                            placeholder="Enter email address"
                            type="email"
                            onChange={validation.handleChange}
                            // onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.email}</div>
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="username" className="form-label">
                            Username <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="username"
                            type="text"
                            placeholder="Enter username"
                            onChange={validation.handleChange}
                            // onBlur={validation.handleBlur}
                            value={validation.values.username || ""}
                            invalid={
                              validation.touched.username &&
                              validation.errors.username
                                ? true
                                : false
                            }
                          />
                          {console.log(validation)}
                          {validation.touched.username &&
                          validation.errors.username ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.username}</div>
                            </FormFeedback>
                          ) : null}
                        </div>
                        {/* testing */}
                        <div className="mb-3">
                          <Label htmlFor="phone" className="form-label">
                            Phone <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="phone"
                            type="text"
                            placeholder="Enter phone number"
                            onChange={validation.handleChange}
                            // onBlur={validation.handleBlur}
                            value={validation.values.phone || ""}
                            invalid={
                              validation.touched.phone &&
                              validation.errors.phone
                                ? true
                                : false
                            }
                            style={{ display: "none" }}
                          />
                          {/* uncomment it on deploy */}
                          <PhoneInput
                            country={"hk"}
                            value={validation.values.phone}
                            onChange={(value) =>
                              validation.setFieldValue("phone", value)
                            }
                            enableSearch={true}
                            inputProps={{
                              required: true,
                            }}
                            isValid={(value, country) => {
                              try {
                                if (value.length <= 3) {
                                  return true;
                                } else {
                                  const phoneNumber =
                                    parsePhoneNumber("+"+value, country.iso2.toUpperCase());

                      
                                  const internationalformat = phoneNumber.formatInternational() 
                                   
                                if(isValidPhoneNumber(internationalformat)){

                                  return true
                                }else{
                                  return `Invalid phone number for ${country.name}`
                                }
                               

                                }
                              } catch (error) {

                                console.log(error)
                                return `Invalid phone number for ${country.name}`
                              }
                            }}
                          />

                          {validation.touched.phone &&
                          validation.errors.phone ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.phone}</div>
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="userpassword" className="form-label">
                            Password <span className="text-danger">*</span>
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3 nbg">
                          <Input
                            name="password"
                            type={passwordShow ? "text" : "password"}
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            // onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.password}</div>
                            </FormFeedback>
                          ) : null}
                          <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon"
                                  onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></button>
                          </div>
                        </div>

                        <div className="mb-2">
                          <Label
                            htmlFor="confirmPassword"
                            className="form-label"
                          >
                            Confirm Password{" "}
                            <span className="text-danger">*</span>
                          </Label>
                            <div className="position-relative auth-pass-inputgroup mb-3 nbg">
                              <Input
                                name="confirm_password"
                                type={confrimPasswordShow ? "text" : "password"}
                                placeholder="Confirm Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.confirm_password || ""}
                                invalid={
                                  validation.touched.confirm_password &&
                                    validation.errors.confirm_password
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.confirm_password &&
                                validation.errors.confirm_password ? (
                                <FormFeedback type="invalid">
                                  <div>{validation.errors.confirm_password}</div>
                                </FormFeedback>
                              ) : null}                          
                              <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon"
                                  onClick={() => setConfrimPasswordShow(!confrimPasswordShow)}><i className="ri-eye-fill align-middle"></i>
                              </button>
                            </div>
                        </div>
                        <div
                          id="password-contain"
                          style={{
                            display:
                              validation.touched.password &&
                              validation.errors.password
                                ? "block"
                                : "none",
                          }}
                          className="p-3 bg-light mb-2 rounded"
                        >
                          <h5 className="fs-13">Password must contain:</h5>
                          <p
                            id="pass-length"
                            className={`${
                              validation.values.password.length >= 8
                                ? "valid"
                                : "invalid"
                            } fs-12 mb-2`}
                          >
                            Minimum <b>8 characters</b>
                          </p>
                          <p
                            id="pass-lower"
                            className={`${
                              /[a-z]/.test(validation.values.password)
                                ? "valid"
                                : "invalid"
                            } fs-12 mb-2`}
                          >
                            At least <b>one lowercase</b> letter (a-z)
                          </p>
                          <p
                            id="pass-upper"
                            className={`${
                              /[A-Z]/.test(validation.values.password)
                                ? "valid"
                                : "invalid"
                            } fs-12 mb-2`}
                          >
                            At least <b>one uppercase</b> letter (A-Z)
                          </p>
                          <p
                            id="pass-number"
                            className={`${
                              /\d/.test(validation.values.password)
                                ? "valid"
                                : "invalid"
                            } fs-12 mb-0`}
                          >
                            At least <b>one number</b> (0-9)
                          </p>
                          {/* <p
                            id="pass-special"
                            className={`${
                              /[@$!%*?&]/.test(validation.values.password)
                                ? "valid"
                                : "invalid"
                            } fs-12 mb-0`}
                          >
                            At least one special character ({'!@#$%^&*()'})
                          </p> */}
                        </div>

                        <div className="mb-4">
                          <div></div>
                          <p className="mb-0 fs-12 text-muted fst-italic d-flex">
                            <Input
                              name="agree_on_terms"
                              onChange={validation.handleChange}
                              //  onBlur={validation.handleBlur}
                              value={validation.values.agree_on_terms}
                              invalid={
                                validation.touched.agree_on_terms &&
                                validation.errors.agree_on_terms
                                  ? true
                                  : false
                              }
                              className="form-check-input"
                              type="checkbox"
                              id="formCheck1"
                              style={{ marginRight: "5px" }}
                            />
                            <span>By registering, you agree to the DBinsight.ai
                            <Link
                              to="/Terms_and_Conditions"
                              className="text-primary text-decoration-underline fst-normal fw-medium"
                              style={{ paddingLeft: "5px" }}
                               target="_blank"
                            >
                              {" "}
                              Terms and Conditions
                            </Link> & <Link
                              to="/Privacy_and_Policy"
                              className="text-primary text-decoration-underline fst-normal fw-medium"
                              style={{ paddingLeft: "5px" }}
                               target="_blank"
                            >
                              {" "}
                              Privacy and Policy
                            </Link></span>
                            {validation.touched.agree_on_terms &&
                            validation.errors.agree_on_terms ? (
                              <FormFeedback type="invalid">
                                <div>{validation.errors.agree_on_terms}</div>
                              </FormFeedback>
                            ) : null}
                          </p>
                        </div>

                        <div className="mt-4">
                          <button
                            disabled={!token}
                            className="btn btn-secondary w-100"
                            type="submit"
                          >
                            {account_details.loading ? (
                              <Spinner size="sm" className="me-2">
                                {" "}
                                Loading...{" "}
                              </Spinner>
                            ) : !token ? (
                              "Verifying reCaptcha..."
                            ) : (
                              "Sign Up"
                            )}
                          </button>
                        </div>

                        {/* <div className="mt-4 text-center">
                                                    <div className="signin-other-title">
                                                        <h5 className="fs-13 mb-4 title text-muted">Create account with</h5>
                                                    </div>

                                                    <div>
                                                        <button type="button" className="btn btn-primary btn-icon waves-effect waves-light"><i className="ri-facebook-fill fs-16"></i></button>{" "}
                                                        <button type="button" className="btn btn-danger btn-icon waves-effect waves-light"><i className="ri-google-fill fs-16"></i></button>{" "}
                                                        <button type="button" className="btn btn-dark btn-icon waves-effect waves-light"><i className="ri-github-fill fs-16"></i></button>{" "}
                                                        <button type="button" className="btn btn-info btn-icon waves-effect waves-light"><i className="ri-twitter-fill fs-16"></i></button>
                                                    </div>
                                                </div> */}
                      </Form>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-4 text-center">
                  <p className="mb-0">
                    Already have an account ?{" "}
                    <Link
                      to="/login"
                      className="fw-semibold text-secondary text-decoration-underline"
                    >
                      {" "}
                      Signin{" "}
                    </Link>{" "}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default Register;
